import React from 'react'
import { AttachmentList } from 'components/Attachments/AttachmentList'
import type { ExistingAttachment } from 'components/Attachments/AttachmentList'

const attachments: ExistingAttachment[] = [
  {
    id: 1,
    filename: 'proposal.pdf',
    size: 204800,
    file_url: '#',
  },
  {
    id: 2,
    filename: 'logo.png',
    size: 51200,
    file_url: '#',
  },
]

export function AttachmentsMock(): React.ReactElement {
  return (
    <div className="w-full">
      <AttachmentList attachments={attachments} />
    </div>
  )
}
